import { TemporaryAccessTokenCreateRequestBody } from "@gocardless/api/dashboard/types";
import {
  Button,
  ButtonVariant,
  ButtonSize,
  Glyph,
  Separator,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { PasswordResetCardLayout } from "./PasswordResetCardLayout";

import { ResendEmailButton } from "src/components/routes/ForcedPasswordReset/PasswordResetCards/ResendEmailButton";

interface PasswordResetCardProps {
  banner?: React.ReactElement;
  title: React.ReactElement;
  description: React.ReactElement;
  showGoToDashboardButton?: boolean;
  showSignOutButton?: boolean;
  image: React.ReactElement;
  submit: (requestBody: TemporaryAccessTokenCreateRequestBody) => void;
  userEmail?: string;
  handleSignOut?: () => void;
}

const ForcedPasswordResetCard = ({
  showGoToDashboardButton = false,
  showSignOutButton = false,
  submit,
  userEmail,
  handleSignOut,
  ...rest
}: PasswordResetCardProps) => {
  const handleClick = () => {
    submit({ delay_password_reset: true });
  };

  return (
    <PasswordResetCardLayout
      {...rest}
      buttons={
        <>
          <ResendEmailButton userEmail={userEmail} />
          {showGoToDashboardButton && (
            <>
              <Separator
                spacing={0.25}
                direction="inline-vertical"
                thickness={0}
              />
              <Button
                rightIcon={Glyph.ArrowForward}
                variant={ButtonVariant.TextOnLight}
                size={[ButtonSize.Md]}
                onClick={handleClick}
                data-testid="btn-go-to-dashboard"
              >
                <Trans id="forced-reset-password.cta.go-to-dashboard">
                  Go to dashboard
                </Trans>
              </Button>
            </>
          )}
          {showSignOutButton && (
            <>
              <Separator
                spacing={0.25}
                direction="inline-vertical"
                thickness={0}
              />
              <Button
                onClick={handleSignOut}
                variant={ButtonVariant.TextOnLight}
                size={[ButtonSize.Md]}
                data-testid="btn-sign-out"
              >
                <Trans id="Sign out">Sign out</Trans>
              </Button>
            </>
          )}
        </>
      }
    />
  );
};

export default ForcedPasswordResetCard;
